import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getLocations(params = {}) {
  return axios.get('/ajax/locations', { params })
}
export function getBusinessLocations(businessId, params = {}) {
  return axios.get(`/ajax/businesses/${businessId}/locations`, { params })
}
export function getLocation(id) {
  return axios.get(`/ajax/locations/${id}`)
}
export function createLocation(businessId, data) {
  return axios.post(`/ajax/businesses/${businessId}/locations`, data)
}
export function updateLocation(id, data) {
  return axios.patch(`/ajax/locations/${id}`, data)
}
export function destroyLocation(id) {
  return axios.delete(`/ajax/locations/${id}`)
}
